import React, { useState, useEffect } from 'react';
import './Hero.css';

import homelogo from "../images/logo.png";
import Nav from './Nav';
const ImageSlider = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  

 

  useEffect(() => {
    // Set up an interval to automatically change the image every 5 seconds
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 2000); // 5000 ms = 5 seconds

    // Clean up the interval on component unmount
    return () => clearInterval(interval);
  }, [images.length]);

  if (!images || images.length === 0) {
    return <p>No images available</p>;
  }

  const handleBarClick = (index) => {
    setCurrentIndex(index);
  };

 
  return (
    <div className="slider-container">
      {/* Logo and Hamburger Menu */}
      <Nav logo={homelogo} logoSize = '150px'   plusColor="white" style={{ "--hamburger-color": "white" }}/>
      <img 
        src={images[currentIndex].url}
        alt={`Slide ${currentIndex + 1}`} 
        className="slide-image" 
      />

      {/* Image Title */}
      <div className="image-title">
        {images[currentIndex].title}
      </div>

      {/* Numbered bars or dots */}
      <div className="number-bar">
        {images.map((image, index) => (
          <div
            key={index}
            className={`bar-box ${currentIndex === index ? 'active' : ''}`}
            onClick={() => handleBarClick(index)}
          >
            <div className="number">{(index + 1).toString().padStart(2,'0')}</div>
            <div className={`bar ${currentIndex === index ? 'active' : ''}`}></div>
          </div>
        ))}
      </div>

      
      
    </div>
  );
};

export default ImageSlider;
